













































import ViewInspection from '@/views/Inspection/ViewInspection.vue';
import Action from '@/views/Inspection/ActionPlan/ActionPlan.vue';
import Implementation from '@/views/Inspection/ActionPlan/Implementation.vue';
import Surveyor from '@/views/Inspection/ActionPlan/Surveyor.vue';
import Verification from '@/views/Inspection/ActionPlan/Verification.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
@Component({
  computed: {...mapGetters(['currentTabActionPlan'])},
  methods: {...mapActions(['setCurrentTabActionPlan'])},
  components: {
    ViewInspection,
    Action,
    Implementation,
    Surveyor,
    Verification,
    TabCard,
  },
})
export default class ActionPlan extends Vue {
  setCurrentTabActionPlan: any;
  currentTabActionPlan: any;
  initialTab: String = this.$store.getters.currentTabActionPlan.child || 'actionplan';
  canGetDataFromAPI = false;
  tabs: Array<String> = ['viewinspection', 'actionplan', 'implementation', 'surveyor', 'verification'];
  mounted() {
    if (this.currentTabActionPlan.child !== undefined) {
      this.setCurrentTabActionPlan({
        parent: this.currentTabActionPlan.parent,
        child: this.currentTabActionPlan.child,
      });
      this.setCurrentTabOnLoad(this.currentTabActionPlan.child);
    }
  }

  setCurrentTabOnLoad(activeTab) {
    this.setCurrentTabActionPlan({parent: 'actionplan', child: activeTab});
  }
  changeTab(tab) {
    this.setCurrentTabActionPlan({parent: 'actionplan', child: tab});
    this.canGetDataFromAPI = true;
    //
    // = true;
  }
}
